/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2018 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 */

import {apiUrl, handleApiCall, composeCommonQuery, securedApiOptions, getEnumParams} from './HttpUtils'

const getFleetsApiUrl = (search, sort, sortOrder) => {
    return apiUrl(`fleets`) + composeCommonQuery(search, sort, sortOrder)
}

const getFleetApiUrl = (fleetId) => {
    return apiUrl(`fleets/${fleetId}`)
}

export const fetchSingleFleet = (fleetId) => {
    return handleApiCall(getFleetApiUrl(fleetId))
}

export const fetchFleets = (search, sort, sortOrder, levels) => {
    return handleApiCall(getFleetsApiUrl(search, sort) + (levels ? '&levels=' + levels : ''))
}

export const fetchSubFleets = (fleetId, search, sort, levels) => {
    return handleApiCall(getFleetApiUrl(fleetId) + '/fleets' + composeCommonQuery(search, sort) + (levels ? '&levels=' + levels : ''))
}

export const fetchAssets = (fleetId, search, sort, sortOrder) => {
    return handleApiCall(getFleetApiUrl(fleetId) + '/assets' + composeCommonQuery(search, sort, sortOrder))
}

export const fetchHierarchy = (includeAssets, includeDisabledAssets = false) => {
    return handleApiCall(apiUrl(`fleets/hierarchy?includeAssets=` + includeAssets + '&includeDisabledAssets=' + includeDisabledAssets))
}

export const fetchVariants = (ldiId) => {
    let query = ''
    if (ldiId !== -1 && ldiId != null) {
        query = '?ldiId=' + ldiId
    }
    return handleApiCall(apiUrl('fleets/variants') + query)
}

export const fetchAvailableConfigurationSymptoms = (variants, assetId, ldiId) => {
    let query = '?'
    if (assetId != null) {
        query += '&assetId=' + assetId
    }
    query += '&ldiId=' + ldiId
    query += getEnumParams('variants', variants)
    return handleApiCall(apiUrl('fleets/availableConfigurationSymptoms') + query)
}

export const createFleet = (fleet) => {
    const opts = securedApiOptions()
    opts.method = 'POST'
    opts.body = JSON.stringify(fleet)
    return handleApiCall(apiUrl(`fleets`), opts)
}

export const updateFleet = (fleet) => {
    const opts = securedApiOptions()
    opts.method = 'PUT'
    opts.body = JSON.stringify(fleet)
    return handleApiCall(apiUrl(`fleets/` + fleet.id), opts)
}

export const deleteFleet = (fleetId) => {
    const opts = securedApiOptions()
    opts.method = 'DELETE'
    return handleApiCall(apiUrl(`fleets/` + fleetId), opts)
}

export const createAsset = (asset) => {
    const opts = securedApiOptions()
    opts.method = 'POST'
    opts.body = JSON.stringify(asset)
    return handleApiCall(getFleetApiUrl(asset.fleetId) + '/assets', opts)
}

export const updateAsset = (asset) => {
    const opts = securedApiOptions()
    opts.method = 'PUT'
    opts.body = JSON.stringify(asset);
    return handleApiCall(apiUrl('fleets/assets/' + asset.id), opts)
}

export const enableAsset = (assetId) => {
    const opts = securedApiOptions()
    opts.method = 'PUT'
    return handleApiCall(apiUrl('fleets/assets/enable/' + assetId), opts)
}

export const fetchAttributes = (ldiId) => {
    const query = '?ldiId=' + ldiId
    return handleApiCall(apiUrl('fleets/attributes') + query)

}

export const deleteAsset = (assetId) => {
    const opts = securedApiOptions()
    opts.method = 'DELETE'
    return handleApiCall(apiUrl(`fleets/assets/` + assetId), opts)
}

export const fetchActionLog = (actionTypes, objectTypes) => {
    let query = '?start=0&limit=50';
    query += getEnumParams('actionTypes', actionTypes)
    query += getEnumParams('objectTypes', objectTypes)
    return handleApiCall(apiUrl(`fleets/log`) + query)
}

export const fetchEventLogs = (assetId, objectTypes, actionTypes) => {
    let query = ''
    query += getEnumParams('actionTypes', actionTypes)
    query += getEnumParams('objectTypes', objectTypes)
    return handleApiCall(apiUrl(`fleets/assets/` + assetId + `/eventLogs`) + query)
}
